export default {
  route: {
    dashboard: 'Dashboard', // 首页
    guideInventory: 'GuideInventory view', // 库存查看
    hotelInventory: 'Hotel Price&Inventory management', // 酒店价格
    garden2: 'Royal Garden 2-bedroom Price Management', // 皇家花园2卧价格管理
    garden3: 'Royal Garden 3-bedroom Price Management', // 皇家花园3卧价格管理
    housePrice: 'Hour House Price Management in Chinatown', // 中国城钟点房价格管理
    hotelhourprice24: 'Royal garden 2 bedroom 24 hour room', // 皇家花园2卧24小时房
    fleet: 'Vehicle Inventory Management', // 车队库存管理
    fleetInventory: 'Vehicle Inventory', // 车队库存
    hotelOrders: 'Hotel Order', // 酒店订单
    online_order: 'Online Order', // 线上订单
    SPAorders: 'SPA Order', // SPA订单
    rangeOrders: 'Club Order', // 靶场订单
    fleetorders: 'Vehicle Order', // 车队订单
    fullOrder: 'Full Order', // 全部订单
    hotelFullOrder: 'Hotel Order', // 酒店全部订单
    spaFullOrder: 'Spa Order', // SPA全部订单
    clubFullOrder: 'Club Order', // 靶场全部订单
    carFullOrder: 'Vehicle Order', // 车队全部订单
    virtualOrders: 'Virtual order', // 虚拟订单
    offlineOrder: 'Offline Order', // 线下有效订单
    Offlinevalidorder: 'Valid Offline Order', // 线下无效订单
    Invalid_orders: 'Invalid Order', // 线下待到店
    tobeuser_orders: 'Waiting For Arrival', // 线下已完成
    over_orders: 'Completed Order', // 线下待审核订单
    offline_audit_order: 'To Be Approvalled', // 线下待入住订单
    offline_to_stay_in: 'To Be Checked In', // 线下订单列表
    offlineOrderEntry: 'Add Offline Order', // 线下订单录入
    refundOrder: 'Refund order', // 退款订单
    hotelrefundOrder: 'Hotel Refund Order', // 酒店退款订单
    SPArefundOrder: 'SPA Refund Order', // SPA退款订单
    clubrefundOrder: 'Club Refund Order', // 靶场退款订单
    carrefundOrder: 'Vehicle Refund Order', // 车队退款订单
    UserManagement: 'User management', // 用户管理
    administrators: 'Administrators', // 管理员
    WriteOffUsers: 'Write-off users', // 核销用户
    SystemCustomerService: 'System Customer Service', // 系统客服
    SystemManagement: 'System Management', // 系统管理
    SetModuleCategory: 'Set Module Category', // 分类管理
    SetModule: 'Module Management', // 功能管理
    setRole: 'Role Management', // 角色管理
    SetPermission: 'Permission Management', // 权限管理
    profile: 'Profile', // 个人中心
    clubStock: 'Club Inventory', // 靶场库存管理
    clubStockZhao: 'Club Hq Inventory', // 总部库存管理
    clubDaily: 'Daily Report', // 靶场库存日报
    clubDailyZhao: 'Hq Daily Report', // 总部库存日报
    offlineOrders: 'Offline Order', // 线下订单
    clubPackage: 'Club Packages', // 套餐订购日报
    hotelStatistics: 'Hotel statistics', // 酒店数据统计
    hotelDayStatistics: 'Daily statistics of hotel data', // 酒店数据按天统计
    hotelAllDetail: 'Order Details', // 订单详情
    inputOrder: 'Add Order', // 录入订单
    offlineFreeorder: 'Free Offline Order', // 线下免费订单
    mileageList: 'Vehicle Mileage List', // 车辆行驶公里列表
    damageList: 'Vehicle Damage list', // 车辆损坏列表
    maintenanceList: 'Vehicle Maintenance List', // 车辆保养列表
    vehicleList: 'Vehicle List', // 车辆列表
    vehicleReport: 'Vehicle Daily Report', // 车辆数据日报表
    VehicleUseDrawing: 'Vehicle Using Chart', // 车辆使用图
    driverReport: 'Driver Daily Report', // 司机数据日报表
    monthlyStatement: 'Monthly Settlement Report', // 月结算报表
    checkStatement: 'Check Details', // 查看对账单
    RoyalGarden: 'Royal Garden Order', // 皇家花园订单
    OrderDaily: 'Daily Report', // 订单日报
    OrderMonthlyReport: 'Monthly Report', // 订单月报
    china_town: 'China Town Order', // 中国城订单
    driver_license: 'Driver List',
    message: 'Messages', // 消息中心
    OrderCategories: 'Classified Report', // 订单日报分类
    product: 'Product Management', // 产品管理
    statistics: 'Statistics', // '数据统计'
    all_stats: 'All Statistics', // 全部统计
    hotel_stats: 'Hotel Statistics', // 酒店统计
    club_stats: 'Club Statistics', // 靶场统计
    car_stats: 'Vehicle Statistics', // 车队统计
    timedTaskType: 'Timed task type', // 定时任务类型
    timedTask: 'Timed task' // 定时任务
  },
  navbar: {
    dashboard: 'Dashboard', // 首页
    github: 'Github', // 项目地址
    logOut: 'Log Out', // 退出登录
    profile: 'Profile', // 个人中心
    theme: 'Theme', // 换肤
    size: 'Global Size', // 布局大小
    product_management: 'Product Management', // 产品管理
    order_management: 'Order Management', // 订单管理
    refund_management: 'Refund Management', // 退单管理
    system_management: 'System Management' // 系统管理
  },
  login: {
    title: 'ALP CULTRUE & TOURISM GROUP  MANAGEMENT SYSTEM', // ALP文旅集团管理系统
    logIn: 'Login', // 登录
    username: 'Username', // 账号
    password: 'Password', // 密码
    code: 'Verification Code', // 验证码
    nameMsg: 'Please enter your username', // 请输入用户名
    nameLength: 'Length 5 to 50 characters', // 长度在 5 到 50 个字符
    passwordMsg: 'Please enter your password', // 请输入密码
    passwordLength: 'Length of 6 to 24 characters', // 长度在 6 到 24 个字符
    codeMsg: 'Please enter the verification code.', // 请输入验证码
    bottomInf: '©2019 by ALP CULTRUE & TOURISM GROUP.  All rights reserved.', // 版权信息：©2019 by ALP文旅集团.  All rights reserved.
    tokenFail: 'Token authentication is invalid, please login again' // TOKEN认证失效,请重新登录
  },
  hotel: {
    check_in_time: 'The check-in period is smaller than the current time', // 入住时间段小于当前时间
    name_repeated: 'The name of the check-in person is repeated', // 入住人姓名重复
    passport_number_repeated: 'The passport number of the check-in person is repeated', // 入住人护照号重复
    special_text: 'Please enter special needs', // 请输入特殊需求
    special_requirements: 'Special needs', // 特殊需求
    hotel1: 'Royal Garden 2 beds 1 room', // 皇家花园2卧1房
    hotel2: 'Royal Garden 2 beds 2 room', // 皇家花园2卧2房
    hotelr1: 'Royal Garden 1 beds', // 皇家花园-1房
    hotelr2: 'Royal Garden 2 beds', // 皇家花园-2卧
    hotelr3: 'Royal Garden 3 beds', // 皇家花园-3卧
    hotel24: 'Royal Garden 2 beds 24 hour', // 皇家花园-2卧24小时房
    hotel3: 'Chinatown', // 中国城
    surplus: 'Surplus', // 剩余
    reserve: 'Reserve', // 已预定
    room: 'Room', // 间
    room_tao: 'Room', // 套
    DiscountPrice: 'Discount', // 折扣价
    newPrice: 'New Price', // 新增价格
    goOnline: 'Go online', // 上线
    offline: 'Offline', // 下线
    tips: 'Tip: Modify the selected date in batches', // 提示: 批量修改选中的日期
    Price: 'Price', // 价格
    salesPrice: 'Sales price:', // 销售价:
    discountPrice: 'Discount price:', // 折扣价:
    hourPrice: '-hour sales price:', // 小时销售价:
    hourDiscount: '-hour discount:', // 小时折扣价:
    immediatesubmission: 'Submit', // 立即提交
    reset: 'Reset', // 重置
    Hotel: 'Hotel', // 酒店
    roomtype: 'room', // 房型
    Stock: 'Stock', // 库存
    Validityperiodofprice: 'Validity period of price', // 价格有效期
    starttime: 'Please enter the start time', // 请输入起始时间
    Deadline: 'Please enter the deadline', // 请输入截止时间
    week: 'Week', // 星期
    RoyalGarden: 'Royal Garden', // 皇家花园
    Chinatown: 'Chinatown', // 中国城
    Hourroom: 'Hour Room', // 钟点房
    lying2: '2 lying', // 2卧
    lying3: '3 lying', // 3卧
    Monday: 'Monday', // 周一
    Tuesday: 'Tuesday', // 周二
    Wednesday: 'Wednesday', // 周三
    Thursday: 'Thursday', // 周四
    Friday: 'Friday', // 周五
    Saturday: 'Saturday', // 周六
    Sunday: 'Sunday', // 周日
    cancel: 'cancel', // 取 消
    Determine: 'Determine', // 确 定
    SalesPrice: 'Please enter the sales price', // 请输入销售
    Discountprice: 'Please enter the discount price', // 请输入折扣价
    chooseDate: 'Please choose the date', // 请选择日期
    enterStock: 'Please enter stock', // 请输入库存
    enterNumber: 'Please enter a number', // 请输入数字
    chooseone: 'Please choose at least one', // 请至少选择一个
    fullyBooked: 'Fully Booked', // 已订满
    noSet: 'No Set', // 未设置
    stock_all: 'Total number of remaining intervals', // 剩余间数合计
    booked_all: 'Total number of rooms booked', // 已预订间数合计
    checkedin_all: 'The number of rooms is being added up', // 正在入住间数合计
    finished_all: 'Total number of checked and returned rooms', // 已入住退房间数合计
    finished: 'Checked out', // 已入住退房
    check_in: 'Is to stay in', // 正在入住

    // 订房报告
    reservation_report: 'Reservation Report', // '订房报告'
    arrivals: 'Arrivals', //  '抵达',
    staying: 'Staying', // 住宿中
    departures: 'Departures', // '退房'

    // 房间生产报告
    segment: 'Segment', // '段',
    lodging: 'Lodging', // '住宿',
    pax: 'Pax', // 人数
    avrg_rmrate: 'Avrg rmrate', // '平均房价',
    MTDRoom: 'MTDRoom', // '本月至今房数',
    YTDRoom: 'YTDRoom', // '年初至今房数'

    // 客房收入报告
    service: 'Service', // '服务费',
    GovernmentTax: 'GovernmentTax', // '政府税',

    day_nett: 'Day Nett', // '日净利润',
    day_cros: 'day Gros', // '日毛利',

    month_nett: 'MTD Nett', // '月净利润',
    month_cros: 'MTD Gros', // '月毛利',

    year_service: 'YTD Nett', // '年净利润',
    year_cros: 'YTD Gros' // '年毛利'
  },
  fleet: {
    GeneratingInventory: 'Generating Inventory', // 生成库存
    Vehicletype: 'Vehicle type', // 车型
    seaLion: 'Hiace', // 海狮
    serena: 'Serena', // 塞丽娜
    fugu: 'Classic Car', // 复古车
    Typeofoperation: 'Type of operation', // 操作类型
    increase: 'Increase', // 增加
    reduce: 'Reduce', // 减少
    service_time: 'Service time', // 服务时长
    cost_price: 'Nett Rate', // 市场成本价
    sales_price: 'Publish Rate', // 市场销售价
    hours: 'hour', // 小时
    noSet: 'Not set up', // 未设置
    car: 'Vehicle' // 辆
  },
  clubStock: {
    time: 'Date', // 日期
    consume: 'Consume', // 消耗
    sn: 'Sn', // 订单号
    stockStatus: 'Stock Status', // 库存增加/减少
    surplus: 'Surplus', // 剩余
    total: 'Total', // 汇总
    order_num: 'Number of Order', // 订单数量
    daily_rules: 'Total number of packages per day = cumulative number of packages per order. According to the arrival time, the "completed" status order data of the day before arrival are calculated.' // 统计“已完成”状态，且到店时间也在当天的订单。
  },
  users: {
    a: 'Added Administrator', // 新增管理员
    b: 'Additional Users for Write-off', // 新增核销用户
    NewCustomerService: 'New Customer Service', // 新增客服
    c: 'Edit', // 编辑
    d: 'Prohibit', // 禁用
    e: 'Normal', // 正常
    f: 'User name', // 用户名
    g: 'Nickname', // 昵称
    h: 'Password', // 密码
    i: 'Email', // 邮箱
    j: 'Phone', // 手机号
    k: 'State', // 状态
    i1: 'Permission group selection', // 权限组选择
    picture: 'Picture', // 图片
    del: 'Delete', // 删除
    UploadCode: 'Upload two-dimensional code', // 上传二维码
    SelectPictures: 'Select Pictures', // 选取图片
    ff: 'Enter one user name', // 请输入用户名
    gg: 'Please enter a nickname', // 请输入昵称
    ggb: 'Length of 5 to 50 characters', // 长度在 5 到 50 个字符
    ggc: 'Length of 0 to 20 characters', // 长度在 0 到 20 个字符
    hh: 'Please input a password', // 请输入密码
    ii: 'Please enter your email address', // 请输入邮箱
    iib: 'Please enter the correct email address', // 请输入正确的邮箱
    jj: 'Please enter your cell phone number', // 请输入手机号
    jjb: '11-bit pure number', // 11位纯数字
    ii1: 'Please choose', // 请选择
    l: 'Last landing time', // 最后登陆时间
    m: 'Creation time', // 创建时间
    n: 'Update time', // 更新时间
    o: 'Operation', // 操作
    p: 'Get activation code' // 获取激活码
  },
  print: 'Print', // 打印
  order: {
    actualTime: 'Arrival time / departure time (actual)', // 到店时间/离店时间(实际)
    QuickCheckInTime: 'Quick check in time', // 入住时间快速查询
    Amountcalculationmethod: 'Calculation Method', // 金额计算方式
    Oneway: 'Method 1:\ncalculate unit price automatically', // 方式一 自动计算单价
    Modetwo: 'Method 2:\nautomatic total price calculation', // 方式二 自动计算总价
    registrationForm: ' Registration Form', // 登记表
    t_AOEO: 'Total amount of eligible orders: ', // 符合条件的订单合计总金额
    sum_to: 'sum to', // 共计
    new_order: 'If you have any new order, please deal with it in time', // 您有新订单，请及时处理
    room_type: 'Room Type', // 房间类型
    yes: 'yes', // 是
    no: 'no', // 否
    Whether_hours: 'Whether to check in 24 hours', // 是否24小时入住
    course_reversal: 'Return FLT', // 返航
    fall_to_the_ground: 'Landing FLT', // 落地
    FLT_No_num: 'FLT No', // 请填写航班号
    FLT_No: 'FLT No', // 航班号
    Tobesubmitted: 'To be submitted', // 待提交
    Tobepaid: 'To be paid', // 待支付
    confirmed: 'Inventory to be confirmed', // 待确认库存
    Stayin: 'Stay in', // 待入住
    Tobeused: 'To be used', // 待使用
    StayStore: 'Stay Store', // 待到店
    to_be_confirmed: 'to be confirmed', // 待确认
    Completed: 'Completed', // 已完成
    undo: 'Rescinded', // 已撤销
    Applicationforrefund: 'Application for refund', // 申请退款
    Toberefunded: 'To be refunded', // 待退款
    HasRefunded: 'Refunded', // 已退款
    have_expired: 'have expired', // 已过期
    refused: 'refused', // 已拒绝
    Partialrefund: 'Partial refund', // 部分退款
    Failuretopay: 'Failure to pay', // 支付失败
    Failureofrefund: 'Failure of refund', // 退款失败
    Refundauditfailed: 'Refund audit failed', // 退款审核失败
    Paymentoverdue: 'Payment overdue', // 支付过期
    Cancellationoforder: 'Cancellation of order', // 取消订单
    Wechat: 'Wechat Public Number', // 微信公众号
    applet: 'Wechat applet', // 微信小程序
    Computer: 'Computer side', // 电脑端
    Otherchannels: 'Other channels', // 其它渠道
    Startingorder: 'Starting time of placing order', // 下单开始时间
    Deadlineorders: 'Deadline for placing orders', // 下单时间截止
    DepartureBegins: 'Departure Date Begins', // 离店日期开始
    Departuredeadline: 'Departure Deadline', // 离店日期截止
    ApplicationBegins: 'Application Date Begins', // 申请日期开始
    Applicationdeadline: 'Application Deadline', // 申请日期截止
    AuditBegins: 'Audit Date Begins', // 审核日期开始
    Auditdeadline: 'Audit deadline', // 审核日期截止
    operation: 'Operation', // 操作
    cancelled: 'Cancelled', // 已取消
    cancel: 'Cancel', // 取消
    save: 'Save', // 保存
    preserving: 'Preserving', // 保存中
    details: 'Details', // 查看详情
    information: 'Basic Information', // 基本信息
    order_sn: 'Booking No.', // 订单编号
    refund_sn: 'Refund SerialNo', // 退款单号
    client_type: 'Source', // 订单来源
    created: 'Time', // 下单时间
    order_status: 'Status', // 订单状态
    order: 'Order', // 订单
    cancel_desc: 'Cancel Desc', // 变更政策
    remark: 'Remarks', // 备注
    special_remark: 'Special Remark', // 特殊需求
    refund: 'Refund', // 退款
    reservation_information: 'Booking Information', // 预定信息
    order_amount: 'Order Amount', // 订单金额
    product_price: 'Unit Price', // 单价
    product: 'Product', // 预定服务
    service_name: 'Service Name', // 预定服务
    product_num: 'Product Num', // 预定数量
    people_num: 'People Num', // 人数
    start_time: 'Start Time', // 到店时间
    selectOrder: 'Please select the source of the order', // 请选择订单来源
    HotelType: 'Hotel Room Type', // 酒店房型
    selectDate: 'Choose a date', // 选择日期
    SelectionTimePeriod: 'Selection of time period', // 选择时间段
    Starttime: 'Start time', // 开始时间
    Endtime: 'End time', // 结束时间
    choosetime: 'Please choose the start time', // 请选择开始时间
    CheckOutDate: 'Check-out date', // 退房日期
    ChooseADte: 'Choose a date', // 选择日期
    Quantity: 'Quantity', // 数量
    Currency: 'Currency', // 币种
    PaymentAmount: 'Payment Amount', // 支付金额
    ResidentInformation: 'Guest Infor', // 入住人信息
    Room: 'Room', // 房间
    NameOccupant: 'Guest Name', // 入住人姓名
    PassportNumber: 'Passport number', // 护照号
    RoomNumber: 'Room Number', // 房间号
    yourName: 'Please fill in your name', // 请填写姓名
    yourPassportNumber: 'Please fill in your passport number', // 请填写护照号
    roomnumber: 'Room number', // 请填写房间号
    Stayinstructions: 'Notes', // 入住说明
    checkinstructions: 'Please enter the Notes', // 请输入入住说明
    addcheck_in: 'Notes', // 添加入住说明
    Createitnow: 'Create It Now', // 立即创建
    Cancel: 'Cancel', // 取消
    CancelOrder: 'Cancel Order', // 取消订单
    ExamineOrder: 'Examine Order', // 审核订单
    ConfirmArrival: 'Confirm Arrival', // 确认到店
    AreYouSureConfirmArrival: 'Are You Sure Confirm Arrival', // 是否确认到店
    cannotConfirmArrival: 'No check-in was made on the prescribed date.', // 未在规定日期办理入住。
    CheckOut: 'CheckOut', // 离店退房
    AreYouSureCheckOut: 'Are You Sure Check Out', // 是否确认离店退房
    ConfirmClub: 'Confirm Club', // 核销
    AreYouSureConfirmClub: 'Are You Sure Confirm Club', // 是否确认核销订单
    AreYouSureConfirmCancel: 'Are You Sure Confirm Cancel', // 是否确认取消
    ChinatownHourHouse: 'Chinatown - Hour House', // 中国城-钟点房
    Undertheline: 'Under the line', // 线下
    ailvpai: 'AILVPAI', // 爱旅拍
    lvxingshe: 'Travel Agency', // 旅行社
    shibeikeji: 'Shi Bei Ke Ji', // 拾贝科技
    shanshuidichan: 'Shan Shui Di Chan', // 山水地产
    Other: 'Other', // 其他
    RMB: 'RMB', // 人民币
    Rupiah: 'Rupiah', // 印尼盾
    usd: 'Dollar', // 美 金
    namecannot: 'The occupant is name cannot be empty', // 入住人姓名不能为空
    Passportempty: 'Passport number cannot be empty', // 护照号不能为空
    Roomempty: 'Room number cannot be empty', // 房间号不能为空
    Successful: 'Successful Order Creation', // 创建订单成功
    EnterOrderNumber: 'Booking No.', // 输入订单编号
    Inputrefundnumber: 'Input refund number', // 输入退款编号
    HotelName: 'Hotel Name', // 酒店名称
    Checkedin: 'Checked In', // 已入住
    Enterorders: 'Enter Orders', // 录入订单
    Checktimebegins: 'Check-in time begins', // 入住时间开始
    Checktime: 'Check-in time', // 入住时间
    Checkdeadline: 'Check-in deadline', // 入住时间截止
    check_in_start: 'Check-in time begins', // 办理入住日期开始
    check_in_end: 'Check-in deadline', // 办理入住日期截止
    actual_start: 'Actual check-in time begins', // 实际入住时间开始
    actual_end: 'Actual check-in time end', // 实际入住时间截止
    hotel: {
      unit_price: 'Unit Price', // 单价
      total_money: 'Total Amount', // 总金额
      product: 'Hotel', // 酒店
      product_model: 'Room Type', // 房型
      service_name: 'Room Type', // 房型
      start_time: 'Check In Date', // 入住日期
      end_time: 'Check Out Date', // 退房日期
      product_num: 'Number Of Rooms', // 间数
      tao: 'Units', // 套数
      days: 'Days', // 天数
      product_info: 'Daily price details (including taxes)', // 每日价格详情(含税)
      room: 'room', // 房间
      name: 'Guest Name', // 入住人
      tourist: 'Guest Name', // 入住人
      room_num: 'Room Number', // 房间号
      remark: 'Notes', // 入住说明
      room_type_2_1: '2 Bedroom Villa Of 1 room', // 2卧室1房别墅
      room_type_2_2: '2 Bedroom Villa Of 2 rooms', // 2卧室2房别墅
      room_type_2_24: '2 Bedroom Villa Of 24 hours room', // 2卧室24小时房
      room_type_3: '3 Bedroom Villa', // 3卧室别墅
      room_type_hour: 'Hour room', // 钟点房
      tip1: 'Check in time is earlier than 12 o\'clock of the day, and you will stay one more night' // 入往时间早于当日12点，会多入住1晚'
    },
    car: {
      start_time: 'Start Time', // 包车时间
      service_name: 'Service Name', // 车型
      start_date: 'Charter date', // 包车日期
      receiving_time: 'Pickup Time', // 接客时间
      uses: 'Purpose', // 用途
      pack_up: 'Retract', // 收起
      look_over: 'See' // 查看
    },
    username: 'Username', // 昵称
    tourist: 'Guest Information', // 客人信息
    certificateNum: 'Certificate No.', // 证件号
    id_no: 'Id_no', // 护照
    id_no_ID: 'ID', // 身份证
    id_no_passport: 'Passport', // 护照
    id_no_militaryID: 'Military ID', // 军官证
    address: 'Address', // 接送地址
    come_address: 'Pickup Location', // 接客地点
    sent_address: 'Final Destination', // 送客地点
    refund_reasons: 'Reasons for refund', // 退款原因
    cancel_reasons: 'Reasons for cancel', // 取消原因
    refund_order_reasons: 'Reasons for cancel', // 退单原因
    examine_reasons: 'Reasons for examine', // 审核备注
    addremark: 'Add Remark', // 添加备注
    payment_information: 'Payment information', // 支付信息
    paid: 'Paid', // 支付时间
    pay_type: 'Payment Method', // 支付方式
    pay_fee_type: 'Currency of Payment', // 支付币种
    pay_order_sn: 'Payment Order SN', // 支付订单号
    real_amount: 'Payment Amount', // 支付金额
    refund_money: 'Refund Amount', // 退款金额
    refunded: 'Refunded', // 申请退款日期
    request_amount: 'Request Amount', // 申请退款金额
    approvalled: 'Approvalled', // 实际退款日期
    log: {
      title: 'Order Record', // 订单日志
      created: 'Operation Time', // 操作时间
      username: 'Operator', // 操作人
      action: 'Order Type', // 操作类型
      status: 'Status' // 订单状态
    },
    refundType: 'Refund Type', // 退款类型
    refundTypeOptions: {
      Full_refund: 'Full refund', // 全额退款
      Partial_refund: 'Partial refund', // 部分退款
      Refusal_refund: 'Refusal of refund' // 拒绝退款
    },
    refund_remark_null: 'Please enter the reason of refund', // 请输入退款原因
    cancel_remark_null: 'Please enter the reason of cancel', // 请输入取消原因
    save_success: 'Saved successful', // 保存成功
    refund_success: 'Refund successful', // 订单退款成功
    cancel_success: 'Cancelled successful', // 订单取消成功
    tourname: 'Tourname', // 导游姓名
    copiesNum: 'Number of copies', // 份数
    order_type: 'Order Type', // 订单类型
    package_name: 'Package name', // 套餐名称
    discount_type: 'Discount type', // 折扣类型
    chargeback: 'Chargeback' // 退单
  },
  setting: {
    add: 'Add', // 新增
    addMenu: 'Add Menu', // 新增菜单
    addPer: 'Add Permission', // 新增权限
    addRole: 'Add Role', // 新增角色
    addModuleCategory: 'Add Module Category', // 新增分类
    choseMenu: 'Chose Menu', // 选择菜单组
    choseParent: 'Chose Parent', // 选择父级功能
    choseCategory: 'Chose Category', // 选择分类
    filter: 'Filter', // 筛选
    available: 'Available', // 可用
    disable: 'Disable', // 禁用
    enable: 'Enable', // 启用
    operating: 'Operating', // 操作
    edit: 'Edit', // 编辑
    modify: 'Modify', // 修改
    please_choose: 'Please Choose ', // 请选择
    please_enter: 'Please Enter ', // 请输入
    clear: 'Clear', // 清空
    save: 'Save', // 保存
    sure: 'I\'m sure', // 确
    cancel: 'Cancel', // 取
    name: 'Name', // 名称
    alias: 'Alias', // 别名
    route: 'Route', // 路由
    status: 'Status', // 状态
    category_id: 'Category Id', // 分类名称
    sort_pos: 'Sort Pos', // 排序
    parent_id: 'Parent Id', // 父功能名称
    created: 'Created', // 创建时间
    updated: 'Updated', // 更新时间
    superior_menu: 'Superior Menu', // 父级
    funtion_name: 'funtion Name', // 功能名称
    lang: 'Lang', // 多语言设置
    rules_name: 'Please enter a name', // 请输入名称
    rules_alias: 'Please enter a alias', // 请输入别名
    rules_alias_length: 'Composition of 3-50-bit letters and underlines', // 3-50位字母、下划线组成
    rules_sort_pos: 'Enter Functional Sorting (Numbers)', // 请输入排序
    rules_sort_pos_number: 'Sort into numbers', // 排序为数字
    rules_status: 'Please select the default state', // 请选择默认状态
    rules_controller: 'lease enter a controller', // 请输入权限控制器
    root: 'Root', // 根目录
    success: ' success', // 成功
    fail: 'fail', // 失败
    per_name: 'permission name', // 权限名称
    controller: 'Controller', // 接口控制器
    permission: 'Permission', // 关联权限
    category: 'Category', // 关联分类
    effective: 'Effective after re-login', // 重新登录后生效
    editStock: 'Edit Stock', // 增加
    empty: 'Empty', // 当前为空
    tel: 'Telephone', // 联系方式
    name_cn: 'Chinese Name', // 中文名称
    name_en: 'English Name', // 英文名称
    name_in: 'Indonesian Name', // 印尼名称
    Chinese: 'Chinese', // 中文
    English: 'English', // 英文
    Indonesia: 'Indonesia', // 印尼
    icon: 'Icon', // 图标
    show: 'Show', // 显示
    hide: 'Hide', // 隐藏
    copy: 'Copy' // 复制
  },
  documentation: {
    documentation: 'Documentation', // 文档
    github: 'Github Repository' // Github 地址
  },
  permission: {
    addRole: 'New Role', // 新增角色
    editPermission: 'Edit', // 编辑权限
    roles: 'Your roles', // 你的权限
    switchRoles: 'Switch roles', // 切换权限
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.', // 在某些情况下，不适合使用
    delete: 'Delete', // 删除
    confirm: 'Confirm', // 确定
    cancel: 'Cancel' // 取消
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ', // 引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于
    button: 'Show Guide' // 打开引导
  },
  components: {
    documentation: 'Documentation', // 文档
    tinymceTips: 'Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.', // 富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见
    dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.', // 由于我司业务有特殊需求，而且要传七牛
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.', // 当页面滚动到预设的位置会吸附在顶部
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner', // 页面滚动到指定位置会在右下角出现返回顶部按钮
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally', // 可自定义按钮的样式、show
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.' // 由于我在使用时它只有vue
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order', // 固定表头, 按照表头顺序排序
    dynamicTips2: 'Not fixed header, sorted by click order', // 不固定表头, 按照点击顺序排序
    dragTips1: 'The default order', // 默认顺序
    dragTips2: 'The after dragging order', // 拖拽后顺序
    title: 'Title', // 标题
    importance: 'Imp', // 重要性
    type: 'Type', // 类型
    remark: 'Remark', // 点评
    search: 'Search', // 搜索
    add: 'Add', // 添加
    export: 'Export', // 导出
    reviewer: 'reviewer', // 审核人
    id: 'No.', // 序号
    date: 'Date', // 时间
    author: 'Author', // 作者
    readings: 'Readings', // 阅读数
    status: 'Status', // 状态
    actions: 'Actions', // 操作
    edit: 'Edit', // 编辑
    publish: 'Publish', // 发布
    draft: 'Draft', // 草稿
    delete: 'Delete', // 删除
    cancel: 'Cancel', // 取 消
    confirm: 'Confirm', // 确 定
    number: 'Number' // 编号
  },
  example: {
    warning: 'Creating and editing pages cannot be cached by keep-alive because keep-alive include does not currently support caching based on routes, so it is currently cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or do not use keep-alive include to cache all pages directly. See details' // 创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner', // 请点击右上角bug小图标
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.', // 现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。
    documentation: 'Document introduction' // 文档介绍
  },
  excel: {
    export: 'Export', // 导出
    selectedExport: 'Export Selected Items', // 导出已选择项
    placeholder: 'Please enter the file name (default excel-list)' // 请输入文件名(默认excel-list)
  },
  zip: {
    export: 'Export', // 导出
    placeholder: 'Please enter the file name (default file)' // 请输入文件名(默认file)
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading PDF.' // 这里使用   window.print() 来实现下载pdf的功能
  },
  theme: {
    change: 'Change Theme', // 换肤
    documentation: 'Theme documentation', // 换肤文档
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.' // Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。
  },
  tagsView: {
    refresh: 'Refresh', // 刷新
    close: 'Close', // 关闭
    closeOthers: 'Close Others', // 关闭其它
    closeAll: 'Close All' // 关闭所有
  },
  settings: {
    title: 'Page style setting', // 系统布局配置
    theme: 'Theme Color', // 主题色
    tagsView: 'Open Tags-View', // 开启 Tags-View
    fixedHeader: 'Fixed Header', // 固定 Header
    sidebarLogo: 'Sidebar Logo' // 侧边栏 Logo
  },
  clubOrders: {
    clubOrders_ddh: 'Order number', // 订单号
    clubOrders_ddly: 'Source of order', // 订单来源
    clubOrders_ddlx: 'Sales type', // 销售类型
    clubOrders_yhxm: 'User Name', // 用户姓名
    clubOrders_fs: 'Number of copies', // 份数
    clubOrders_rs: 'Number of people', // 人数
    clubOrders_tcsl: 'Number of package', // 套餐数量
    clubOrders_ddsj: 'Shop arrival time', // 到店时间
    clubOrders_tclx: 'Package type', // 套餐类型
    clubOrders_zkfs: 'Discount method', // 折扣方式
    clubOrders_skbz: 'Receivable currency', // 收款币种
    clubOrders_skfs: 'Payment method', // 收款方式
    clubOrders_sjskje: 'Actual amount of receipt', // 实际收款金额
    clubOrders_ddzt: 'Order status', // 订单状态
    clubOrders_xdsj: 'Order time', // 下单时间
    clubOrders_rmbskje: 'RMB amount', // 人民币收款金额
    clubOrders_idrskje: 'IDR amount', // 印尼盾收款金额
    clubOrders_usdskje: 'USD amount', // 美元收款金额
    clubOrders_lrxxdd: 'Input offline orders', // 录入线下订单
    clubOrders_yx: 'A pin', // 一销
    clubOrders_ex: 'The second pin', // 二销
    clubOrders_yj: 'Original price', // 原价
    clubOrders_bz: '20 percent off', // 8折
    clubOrders_mf: 'Free Admission', // 免费
    clubOrders_rmb: 'RMB', // 人民币
    clubOrders_ynd: 'IDR', // 印尼盾
    clubOrders_mj: 'USD', // 美金
    clubOrders_wx: 'WeChat', // 微信
    clubOrders_zfb: 'Alipay', // 支付宝
    clubOrders_xx: 'Offline payment', // 线下支付
    clubOrders_sk: 'Pay by card', // 刷卡
    clubOrders_xj: 'Cash', // 现金
    clubOrders_xxddlr: 'Entry offline order ', // 线下订单录入
    clubOrders_xzddly: 'Please select the source of the order.', // 请选择订单来源
    clubOrders_dyxm: 'Name of tour guide', // 导游姓名
    clubOrders_lxsmc: 'Name of travel agency', // 旅行社名称
    clubOrders_jsdz: 'Delivery Address', // 接送地址
    clubOrders_xztc: 'Optional Package', // 选择套餐
    clubOrders_xz: 'Choice', // 选择
    clubOrders_tcmc: 'Name of package', // 套餐名称
    clubOrders_zds: 'Number of bullets', // 子弹数
    clubOrders_zdxh: 'Bullet Model', // 子弹型号
    clubOrders_yndjg: 'Indonesian Shield Price', // 印尼盾价格
    clubOrders_yndskjg: 'Indonesian Shield Receivable Amount', // 印尼盾收款金额
    clubOrders_srrmbskje: 'Please enter the amount of RMB receipt', // 请输入人民币收款金额
    clubOrders_srmjskje: 'Please enter the amount of receipt in US dollars.', // 请输入美元收款金额
    clubOrders_beizhu: 'Remarks', // 备注
    clubOrders_scdd: 'Generating orders', // 生成订单
    clubOrders_srdyxm: 'Please enter the name of the tour guide.', // 请输入导游姓名
    clubOrders_srlvsmc: 'Please enter the name of the travel agency.', // 请输入旅行社名称
    clubOrders_srskje: 'Please enter the amount of the receipt.', // 请输入收款金额
    clubOrders_srfs: 'Please enter the number of copies.', // 请输入份数
    clubOrders_srrs: 'Please enter the number of people' // 请输入人数
  },
  hotelAllData: {// 酒店数据统计
    hotelAllData_hj: 'Total', // 合计
    hotelAllData_fjs: 'Number Of Rooms', // 房间数
    hotelAllData_je: ' Amount', // 金额
    hotelAllData_drz: 'Stay in', // 待入住
    hotelAllData_yrz: 'Checked in', // 已入住
    hotelAllData_jrdrz: 'Stay in today', // 今日待入住
    hotelAllData_jryrz: 'Checked in today', // 今日已入住
    hotelAllData_zrdrz: 'Stay in yesterday', // 昨日待入住
    hotelAllData_zryrz: 'Checked in yesterday', // 昨日已入住
    hotelAllData_yzdrz: 'Stay in for the last week', // 最近一周待入住
    hotelAllData_yzyrz: 'Checked in for the last week', // 最近一周已入住
    hotelAllData_yydrz: 'Stay in the last month', // 最近一个月待入住
    hotelAllData_yyyrz: 'Has been admitted in the last month'// 最近一个月已入住
  },
  carOrders: {
    is_operate_car: 'Operational Vehicles Or Not', // 是否运营车
    driving_date: 'Driving Date', // 行驶日期
    modify_km: 'Modify Vehicle Kilometers', // 修改车辆使用公里数
    last_maintain_date: 'Last Service Date', // 最后保养日期
    enter_free_orders: 'Enter offline free order', // 录入线下免费订单
    enter_valid_orders: 'Enter offline effective order', // 录入线下有效订单
    order_sn: 'Order No', // 申请单号
    username: 'Guest Name', // 用户姓名
    company: 'Department', // 申请部门
    purpose: 'Purpose', // 用途
    package: 'Package', // 套餐内容
    order_status: 'Status', // 订单状态
    address: 'Pickup Location', // 接客地点
    send_address: 'Final Destinaiton', // 送客地点
    stage_time: 'Pickup Time', // 接客时间
    car_brand: 'Vehicle', // 车辆品牌
    driver: 'Driver', // 司机
    car_license: 'Plate No', // 车牌号
    apply_time: 'Apply Time', // 申请时间
    summary_amount: 'Actual amount of receipt', // 实际收款金额汇总
    service_time: 'Hours', // 时长
    original_type: 'Original type', // 原单类型
    real_amount_rmb: 'Original amount (CNY)', // 原单金额 (CNY)
    real_amount_idr: 'Original amount (IDR)', // 原单金额 (IDR)
    overtime_price_rmb: 'Overtime payment (CNY)', // 超时金额 (CNY)
    overtime_price_idr: 'Overtime payment (IDR)', // 超时金额 (IDR)
    overrange_price_rmb: 'Extraneous amount (CNY)', // 超范围金额 (CNY)
    overrange_price_idr: 'Extraneous amount (IDR)', // 超范围金额 (IDR)
    wait_audit: 'To be examined by leaders', // 待领导审核
    wait_dispatch: 'Pending dispatch', // 待调度分配
    pass_dispatch: 'Dispatching through', // 调度通过
    no_pass_audit: 'Failure of Leadership Audit', // 领导审核不通过
    no_pass_dispatch: 'Dispatch failed', // 调度不通过
    canceled: 'Cancelled', // 已取消
    leader_audit: 'Departmental Leadership Audit', // 部门领导审核
    dispatch_audit: 'Scheduling audit', // 调度审核
    cancel_apply: 'withdraw', // 取消申请
    contact: 'Contact', // 联系方式
    dispatching: 'Dispatching allocation', // 调度分配
    is_receive_guest: 'Punctuality', // 司机是否准时接到客人
    is_on_time: 'Whether pickup the guest on time', // 是否准时接到客人
    content: 'Details', // 内容
    real_arrive_time: 'Actual arrival time:', // 实际到达时间：
    choose_date: 'Choose the date and time', // 选择日期时间
    no_arrive_reason: 'Reasons for not arriving on time:', // 未准时到达原因：
    enter_content: 'Please enter the content', // 请输入内容
    arrive_on_time: 'Arrive on time', // 准时到达
    not_arrive_on_time: 'Not arriving on time', // 未准时到达
    reason: 'Reason:', // 原因：
    time_and_scope: 'Exceeding Time/Exceeding Area', // 超出时长/超出范围
    beyond_time: 'Exceeding Time:', // 超过用车时长：
    beyond_scope: 'Exceeding Area:', // 超过用车范围：
    beyond_price: 'Fill exceeding price', // 填写超出价格
    yuan: 'yuan', // 元
    billing_info: 'Settlement Information', // 结算信息
    pay_method: 'Settlement Terms', // 结算方式
    pay_currency: 'Currency', // 结算币种
    pay_amount: 'Amount', // 应付金额
    is_pass: 'Whether to pass', // 是否通过
    leader_pass: 'Departmental Leadership Approved', // 部门领导通过
    leader_no_pass: 'Departmental leadership failed to pass', // 部门领导不通过
    leader_audit_pass: 'Departmental Leadership Audit Completed', // 部门领导审核完成
    complete_audit: 'Order Scheduling Audit Completed', // 订单调度审核完成
    cancel_suc: 'Cancellation of success', // 取消成功
    dispatch_update_suc: 'Successful update of scheduling information', // 调度信息更新成功
    guest_update_suc: 'Successful update of guest reception information', // 客人接送信息更新成功
    complete_dispatch_first: 'Please complete the scheduling assignment first', // 请先完成调度分配
    choose_amount: 'Please choose the amount in the package', // 请在套餐内选择金额
    choose_amount_pay: 'Please select and enter the payment amount in the package', // 请在套餐内选择并输入支付金额
    choose_price: 'Please choose the price in the package', // 请在套餐内选择价格
    add_suc: 'Add success', // 添加成功
    enter_time: 'Entry time', // 录入时间
    all_license: 'All license plates', // 全部车牌
    enter_mileage: 'Enter vehicle mileage', // 录入车辆使用公里数
    driving_km: 'Driving kilometres', // 行驶公里
    choose_brand: 'Please choose the vehicle brand', // 请选择车辆品牌
    choose_license: 'Please choose the license plate number', // 请选择车牌号
    km: 'kilometre', // 公里
    submit: 'Submit', // 提交
    enter_km: 'Please fill in the number of kilometers', // 请填写公里数
    enter_correct_km: 'Please fill in the correct number of kilometers', // 请填写正确的公里数
    enter_suc: 'Successful entry', // 录入成功
    enter_damage: 'Damage of input vehicles', // 录入车辆损坏情况
    is_repaired: 'Repair or not', // 是否需要维修
    check_damage_info: 'Vehicle damage after dispatch inspection', // 调度查验后车辆损坏情况
    repair_date: 'Repair date', // 维修日期
    repair_info: 'Repair details', // 维修详情
    damage_place_time: 'Vehicle damage, repair site, repair time, etc', // 车损情况，维修地点，维修时长等
    enter_damage_info: 'Please enter vehicle damage information', // 请输入车辆损坏情况
    fix_suc: 'Modified success', // 修改成功
    damage_info: 'Details of Vehicle Damage', // 车辆损坏详情
    maintenance_km: 'Maintenance kilometers', // 保养公里
    is_maintenance: 'Maintenance required', // 是否需要保养
    maintenance_info: 'Details of Vehicle Maintenance', // 车辆保养详情
    maintenance_date: 'Maintenance date', // 保养日期
    main_info: 'Maintenance details', // 保养详情
    main_time_problem: 'Maintenance status, duration, vehicle problems during maintenance, etc', // 保养情况，时长，保养过程中车辆问题等
    choose_maintenance: 'Please choose whether maintenance is required or not', // 请选择是否需要保养
    accumulate_km: 'Accumulated driving kilometres', // 累积行驶公里
    car_status: 'Vehicle condition', // 车辆状态
    normal_use: 'Normal use', // 正常使用
    improper_use: 'Stop using', // 暂停使用
    set_normal: 'Set to normal', // 置为正常
    repair_record: 'Repair record', // 维修记录
    maintenance_record: 'Maintenance record', // 保养记录
    no_data: 'No data', // 暂无数据
    main_km: 'Maintenance kilometres', // 保养时公里
    statistics: 'The Daily News counts the data before yesterday, including yesterday', // 日报统计昨天之前的数据，包括昨天
    date: 'Date', // 日期
    use_summary: 'Summary of usage time', // 使用时长汇总
    free_summary: 'Summary of idle hours', // 空闲时长汇总
    time_summary: 'Summary of working hours', // 工作时长汇总
    choose_month: 'Select month', // 选择月份
    account_state: 'Settlement status', // 结算状态
    account_wait: 'Settlement', // 待结算
    accounted: 'Settled', // 已结算
    month: 'Month', // 月份
    account: 'Settlement', // 结算
    check_talbe: 'Check the reconciliation table', // 查看对帐表
    account_suc: 'Successful settlement', // 结算成功
    enter_price: 'Please enter the price', // 请输入价格
    enter_remark: 'Please enter notes', // 请输入备注
    choose_arrive_time: 'Please select the actual arrival time', // 请选择实际到达时间
    choose_reason: 'Please fill in the reasons for not arriving on time', // 请填写未准时到达原因
    driver_name: 'Driver', // 司机姓名
    recieve_start: 'Start Date', // 接客开始日期
    recieve_end: 'End Date', // 接客结束日期
    details: 'DETAIL', // 查看详情
    enter_driver: 'Enter driver information', // 录入司机信息
    edit_dirver: 'Modify driver information', // 修改司机信息
    is_del: 'Do you want to delete driver', // 是否要删除司机
    tips: 'Tips', // 提示
    enter_driver_name: "Please fill in the driver's name", // 请填写司机姓名
    all: 'All', // 全部
    distribution: 'Waiting for distribution', // 待分配
    using: 'Using', // 使用中
    finished: 'Finished', // 使用完
    car_info: 'Vehicle information', // 车辆信息
    color: 'Color', // 颜色
    valid_date: 'Validity of license', // 车证有效期
    tax_date: 'Last tax date', // 最后纳税日期
    car_date: 'Last car insurance date', // 最后车险日期
    appearance: 'Appearance status', // 外观状况
    belong: 'Belong to', // 属于
    vehicle_num: 'Vehicle identification number', // 车辆识别号
    engine_num: 'Engine number', // 引擎编号
    ownership_num: 'Vehicle has a license number', // 车辆拥有证号码
    ownership_adr: 'Vehicle ownership certificate', // 车辆拥有证所在
    car_adr: 'Vehicle number certificate', // 车号证所在
    capacity: 'Cylinder capacity', // 气缸容量
    made_year: 'Year of manufacture', // 制造年份
    liabilities: 'Indebtedness', // 负债人
    other_info: 'Other information', // 其他信息
    isdel_car: 'Whether to delete the vehicle' // 是否要删除车辆
  },
  chinaTown: {
    upload: 'Import', // 导入数据
    myExportList: 'Imported List', // 导入列表
    name: 'Name', // 名称
    type: 'Type', // 数据类型
    choseFile: 'Chose File', // 选取文件
    choseTip: 'Only one CSV file can be uploaded at a time', // 每次只能导入1个csv文件
    taskName: 'Task Name', // 任务名称
    userName: 'User Name', // 上传人
    created: 'Created', // 导入时间
    again: 'Again', // 重新导入
    paid: 'Payment Date', // 交易时间
    discount_amount: 'Discount Amount', // 折扣额
    service_amount: 'Service Amount', // 服务费
    tax_amount: 'Tax Amount', // 税费
    real_amount: 'Actual Payment Amount', // 实际支付金额
    consumption_data: 'Consumption Data', // 消费数据
    room_data: 'Room Data', // 房间数据
    to_be: 'To be executed', // 待执行
    executing: 'Executing', // 执行中
    finish: 'Finished', // 完成
    failure: 'Failed', // 失败
    noCSV: 'Import format can only be CSV format!', // 导入格式只能是 CSV 格式!
    uploadSuccess: ' sUploadeduccessfully, waiting for import...', // 上传成功，等待录入中...
    user: 'User Name', // 操作员
    ProductInformation: 'Product Information', // 产品信息
    product_id: 'Product Id', // 产品编号
    product_name: 'Product Name', // 产品名称
    product_unit: 'Product Unit', // 计量单位
    after_discount_amount: 'Discount Amount', // 折后金额
    gratuity: 'Gratuity', // 服务费
    guest_name: 'Guest Name', // 客人姓名
    country: 'Country', // 国家
    check_in: 'Check In', // 到店日期
    service_time: 'Service Time', // 入住几晚
    is_additional: 'Extra Bed Or Not', // 是否加床
    total_order_no: 'Total Order Num', // 订单总数
    Today: 'Today', // 今天
    Yesterday: 'Yesterday', // 昨天
    ThisWeek: 'This Week', // 本周
    LastWeek: 'Last Week', // 上周
    ThisMonth: 'This Month', // 本月
    LastMonth: 'Last Month', // 上月
    save_all: 'Save the above changes', // 保存以上修改
    add_pro: 'Add product', // 添加产品
    pro_num: 'Product quantity is at least 1 ！', // 产品数量至少为1
    choose_pro: 'Please choose a product ！', // 请选择产品
    one_pro: 'Please choose at least one product ！', // 请至少选择一个产品
    money_num: 'Order amount is inconsistent with payment amount ！', // 订单金额跟支付金额不一致
    source: 'SOURCE', // 来源
    category: 'CATEGORY', // 品类
    total: 'TOTAL', // 总数量
    total_number: 'TOTAL', // 总份数
    Rakeback: 'Commission', // 返佣
    Cashback: 'Cash Back', // 返现
    Restaurant: 'Restaurant', // 餐饮
    materiel: 'Materiel', // 物料
    GuestRoom: 'GuestRoom', // 客房
    product_type: 'Type', // 产品类型
    Do_want_change_product: 'Do you want to change the product', // 是否要更改产品
    Status_as: 'Status as', // 状态为
    betwn: 'Difference', // 差额
    save: 'Whether to save', // 是否保存
    Repeat_orders: 'Repeat orders', // 重复订单
    sec_type: 'Two level type', // 二级类型
    tip_hour: 'Please enter a few hours', // 请输入几小时
    tip_sec_type: 'Please enter secondary type' // 请输入二级类型
  },
  royalGarden: {
    company: 'Department', // 部门
    trade: 'Trading', // 交易
    username: 'Enter Username', // 录入人
    enter: 'Enter', // 录入
    last_time: 'Last edit time' // 最后编辑时间
  },
  message: {
    Full_reading: 'Full standard reading', // 全标已读,
    is_turnring: 'Whether to receive voice prompt:', // 是否接收声音提示：
    details: 'details' // 详情
  },
  profile: { // 个人中心
    nickname: 'Nickname', // '昵称',
    avatar: 'Avatar', // '头像',
    password: 'Password', // '密码',
    confirmPassword: 'Confirm Password', // '确认密码',
    submit: 'Submit', // '提交',
    reset: 'Reset', // '重置'
    defaultPage: 'Default Page' // '设置默认打开页'
  },
  // 订单共有
  allOrders: {
    btn_today: 'Today', // 今天
    btn_yesterday: 'Yesterday', // 昨天
    btn_this_week: 'This Week', // 本周
    btn_last_week: 'Last Week', // 上周
    btn_this_month: 'This Month', // 本月
    btn_last_month: 'Last Month', // 上月
    btn_all: 'All', // 全部
    btn_select: 'Filter', // 筛选
    btn_details: 'Details', // 查看详情
    btn_submit: 'Submit', // 提交
    btn_save: 'Save', // 保存
    btn_modify: 'Save', // 保存修改
    btn_edit: 'Edit', // 编辑
    btn_del: 'Delete', // 删除
    btn_sure: 'Confirm', // 确定
    btn_cancel: 'Cancel', // 取消
    btn_cancelled: 'Cancelled', // 已取消
    btn_export: 'Export', // 导出
    txt_sum: 'Actual Total Amount', // 实际收款金额汇总
    radio_yes: 'Y', // 是
    radio_no: 'N', // 否
    yuan: 'Yuan', // 元
    header_operate: 'Operation', // 操作
    tip_add_suc: 'Added Successful', // 添加成功
    tip_cancel_suc: 'Cancelled Sucessful', // 取消成功
    tip_save_suc: 'Saved Sucessful', // 保存成功
    tip_back_suc: 'Refund Successful', // 退单成功
    tip_hexiao: 'Verification Successful', // 核销成功
    tip_del: 'Deleted Successful', // 删除成功
    tip_tips: 'Tips', // 提示
    txt_rmb: 'RMB', // 人民币
    txt_ynd: 'KDR', // 印尼盾
    sel_start_date: 'Start Date', // 开始日期
    sel_end_date: 'End Date', // 结束日期
    header_date: 'Date', // 日期
    td_total: 'Total', // 汇总
    btn_pay: 'Confirm To Payment', // 确认付款
    start_zh: '',
    start_en: 'Start at ', // 开始
    using: ' use for ', // 使用
    hours: ' hours' // 小时
  },
  // 车队订单
  carOrder: {
    carShare: { // 车队共有
      // 筛选按钮
      sel_order_sn: 'Order SN', // 申请单号
      sel_username: 'Client', // 用户姓名
      sel_driver_name: 'Driver', // 司机姓名
      sel_car_number: 'Plate No', // 车牌号
      sel_department: 'Department', // 申请部门
      sel_purpose: 'Services', // 用途
      sel_meal: 'Packages', // 套餐内容
      sel_order_state: 'Order Status', // 订单状态
      sel_pickup_start: 'Start date of Pick-up', // 接客开始日期
      sel_pickup_end: 'End date of Pick-up', // 接客结束日期
      sel_entry_date: 'Created Time', // 录入日期
      sel_start_date: 'Start Time', // 开始日期
      sel_end_date: 'End Time', // 结束日期
      // 表头
      header_date: 'Date', // 日期
      header_car_number: 'Plate No', // 车牌号
      header_car_brand: 'Vehicle Type', // 车辆品牌
      header_department: 'Department', // 申请部门
      header_username: 'Client', // 用户姓名
      header_pickup_address: 'Pick-up Location', // 接客地点
      header_pickup_time: 'Pick-up Time', // 接客时间
      header_purpose: 'Services', // 服务
      header_length: 'Hours', // 时长
      header_driver: 'Driver', // 司机
      header_order_state: 'Order Status', // 订单状态
      header_car_state: 'Vehicle State', // 车辆状态
      header_meal: 'Package', // 套餐
      header_original_type: 'Price Type', // 价格类型
      header_original_amount: 'Original Amount', // 原单金额
      header_timeout_amount: 'Overtime Amount', // 超时金额
      header_beyond_amount: 'OutRange Amount', // 超范围金额
      header_apply_time: 'Application Time', // 申请时间
      header_apply_no: 'Application SN', // 申请单号
      // 车辆状态快速查询按钮
      txt_state_sel: 'Vehicle State：', // 车辆状态快速查询
      btn_wait_distribution: 'Waiting For Distribution', // 待分配
      btn_wait_used: 'To Be Used', // 待使用
      btn_using: 'Running', // 使用中
      btn_finished: 'Completion', // 使用完毕（空闲)
      haishi: 'Hiace', // 海狮
      sailina: 'Serena', // 塞丽娜
      fuguche: 'Classic Vehicle', // 复古车
      label_car_brand: 'Vehicle Type', // 车辆品牌
      label_car_number: 'Plate No', // 车牌号
      label_travel_km: 'Travelled Mileage', // 行驶公里
      option_wait_audit: 'Waiting For Approvall', // 待调度审核
      option_wait_dispatch: 'Waiting For Distribution', // 待调度分配
      option_pass_dispatch: 'Approvalled Sucessful', // 调度通过
      option_no_pass_audit: 'Approvalled Failed By Leader', // 领导审核不通过
      option_no_pass_dispatch: 'Approvalled Failed', // 调度不通过
      option_canceled: 'Canelled', // 已取消
      tit_maintain: 'Maintenance Input' // 保养录入
    },
    enterOrder: { // 录入订单
      btn_enter_free_order: 'Add Offline Free Order', // 录入线下免费订单
      btn_enter_valid_order: 'Add Offline Order', // 录入线下订单
      label_order_source: 'Department', // 订单来源
      label_username: 'Client Username', // 用户姓名
      label_phone: 'Client Mobile', // 用户手机
      label_pickup_address: 'Pick-up Location', // 接客地点
      label_send_address: 'Drop-Off Location', // 送客地点
      label_pickup_time: 'Pickup Time', // 接客时间
      label_purpose: 'Service', // 用途
      label_car_brand: 'Vehicle Type', // 车辆品牌
      label_meal: 'Packages', // 选择套餐
      label_remark: 'Remark', // 备注
      tip_order_source: 'Please select department', // 请选择订单来源
      tip_username: 'Please enter client username', // 请输入用户姓名
      tip_phone: 'Please enter client mobile', // 请输入用户联系方式
      tip_pickup_address: 'Please enter pick-up location', // 请输入接客地点
      tip_send_address: 'Please enter drop-off location', // 请输入送客地点
      tip_pickup_time: 'Please enter pickup time', // 请输入接客时间
      tip_purpose: 'Please choose service', // 请选择用途
      tip_meal: 'Please choose packages', // 请选择套餐
      tip_car_brand: 'Please choose vehicle type', // 请选择车辆品牌
      tip_remark: 'Please enter remark', // 请输入备注
      btn_submit: 'Submit', // 立即提交
      btn_cacel: 'Cancel', // 取消
      txt_see_inventory: 'Open Vehicle Inventory', // 查看车队库存
      txt_close_inventory: 'Close Vehicle Inventory', // 收起车队库存
      txt_hour: 'Hours', // 小时
      txt_cost_price: 'Cost Price', // 市场成本价
      txt_sales_price: 'Retail Price', // 市场销售价
      tip_noSet: 'Unset', // 未设置
      tip_car: 'Units', // 辆
      tip_choose_amount: 'Please select the amount in the package', // 请在套餐内选择金额
      tip_choose_amount_pay: 'Please select and enter the payment amount in the package', // 请在套餐内选择并输入支付金额
      tip_choose_price: 'Please select the price in the package'// 请在套餐内选择价格
    },
    viewDetails: { // 查看详情
      title: 'Details', // 详情
      title_basic_info: 'Basic Information', // 基本信息
      title_reserve_info: 'Reservation Information', // 预定信息
      title_guest_info: 'Client Information', // 客人信息
      title_dispatch: 'Distpatched Information', // 调度分配信息
      title_settlement_info: 'Settlement Information', // 结算信息
      title_order_log: 'Order Log', // 订单日志
      title_pickup_guest: 'Does the driver receive the guests on time', // 司机是否准时接到客人
      title_beyond: 'Overtime/Out Of Range', // 超出时长/超出范围
      label_apply_no: 'Order SN', // 申请单号
      label_order_source: 'Department', // 订单来源
      label_order_time: 'Created Time', // 下单时间
      label_remark: 'Remark', // 备注
      label_order_state: 'Order State', // 订单状态
      label_car_state: 'Vehicle State', // 车辆状态
      label_operate: 'Operation', // 操作
      label_pickup_guest: 'Whether to receive guests on time', // 是否准时接到客人
      label_real_arrive_time: 'Actual time of arrival', // 实际到达时间
      tip_choose_date: 'Please select date and time', // 请选择日期时间
      label_no_arrive_reason: 'Reasons for not arriving on time', // 未准时到达原因
      tip_enter_content: 'Please enter content', // 请输入内容
      txt_arrive_on_time: 'Arrive on time', // 准时到达
      txt_not_arrive_on_time: 'Not on time', // 未准时到达
      label_reason: 'Reson：', // 原因
      label_beyond_time: 'Overtime', // 超过用车时长
      label_beyond_range: 'Out Of Range', // 超过用车范围
      btn_leader_audit: 'Approval By Leader', // 部门领导审核
      btn_audit: 'Approval By Dispatcher', // 调度审核
      btn_print_order: 'Print', // 打印订单
      btn_cancel_apply: 'Withdraw', // 取消申请
      header_phone: 'Client Mobile', // 联系方式
      header_send_address: 'Pick-up Loaction', // 送客地点
      header_remark: 'Remark',
      header_amount: 'Amount', // 金额
      header_type: 'Payment Type', // 类型
      header_settle_method: 'Settlement Type', // 结算方式
      header_settle_currency: 'Currency', // 结算币种
      header_pay_method: 'Payment Method', // 支付方式
      header_pay_amount: 'Amount', // 应付金额
      header_operate_time: 'Created', // 操作时间
      header_operate_name: 'Username', // 操作人
      header_operate_type: 'Operation Type', // 操作类型
      header_content: 'Content', // 内容
      tip_price: 'Enter Overtime Amount', // 填写超出价格
      tip_amount: 'Payment Amount', // 支付金额
      txt_undertheline: 'Offline', // 线下
      label_is_pass: 'Pass Or Not', // 是否通过
      radio_leader_pass: 'Pass', // 部门领导通过
      radio_leader_no_pass: 'No Pass', // 部门领导通过
      label_examine_reasons: 'Remark', // 审核备注
      radio_pass_dispatch: 'Pass', // 调度通过
      radio_no_pass_dispatch: 'No Pass', // 调度不通过
      label_cancel_reasons: 'Reason For Withdarwal', // 取消原因
      tip_cancel_reasons: 'Please enter reason for withdrawal', // 请输入取消原因
      tip_nocar: 'The package do not include the vehicle', // 该套餐不含有该车辆
      tip_leader_audit_pass: 'Apporvalled successful by leader', // 部门领导审核完成
      tip_complete_audit: 'Apporvalled successful by dispatcher', // 订单调度审核完成
      tip_dispatch_update_suc: 'Updated successful', // 调度信息更新成功
      tip_guest_update_suc: 'Updated successful', // 客人接送信息更新成功
      tip_choose_arrive_time: 'Please choose the actual arrival time', // 请选择实际到达时间
      tip_choose_reason: 'Please enter reason for not arriving on time', // 请填写未准时到达原因
      tip_enter_price: 'Please enter the price', // 请输入价格
      tip_complete_dispatch_first: 'Please disatch vehicle first'// 请先完成调度分配
    },
    carMileage: { // 车辆行驶公里列表
      btn_enter_mileage: 'Enter Vehicle Mileage', // 录入车辆使用公里数
      txt_title: 'Edit Vehicle Mileage', // 修改车辆使用公里数
      label_travel_date: 'Driving Date', // 行驶日期
      tip_car_number: 'Please choose plate no', // 请选择车牌号
      tip_travel_km: 'Please choose driving mileage', // 请输入行驶公里
      tip_travel_date: 'Please choose driving date', // 请选择行驶日期
      header_travel_km: 'Driving Mileage', // 行驶公里
      header_travel_date: 'Driving Date', // 行驶日期
      header_enter_time: 'Created Time', // 录入时间
      txt_km: 'Kilometers', // 公里
      tip_enter_correct_km: 'Please enter the valid driving mileage'// 请输入正确的行驶公里数
    },
    carDamage: { // 车辆损坏列表
      btn_enter_damage: 'Enter Vehicle Demage', // 录入车辆损坏情况
      txt_title_info: 'Details of Vehicle Damage', // 车辆损坏详情
      header_enter_time: 'Created Time', // 录入日期
      header_repair: 'Repaire Or Not', // 是否需要维修
      label_car_info: 'Vehicle Damage After Dispatch Inspection', // 调度查验后车辆损坏情况
      label_repair: 'Repair Or Not', // 是否需要维修
      label_repair_date: 'Repaired Date', // 维修日期
      label_repair_info: 'Detail Information', // 维修详情
      tip_car_info: 'Please enter the vechile demage information', // 请输入调度查验后车辆损坏情况
      tip_repair_date: 'Please enter repaired date', // 请选择维修日期
      tip_repair_info: 'Vechile demage，repaired location, repaired time etc', // 车损情况，维修地点，维修时长等
      original_img: 'Original Picture', // 原有图片
      upload_img: 'Upload Pictures', // 上传图片
      upload_new_img: 'Upload New Pictures', // 上传新图片
      chose_img: 'Select Pictures', // 选择图片
      chose_img_tip: 'Only JPG / PNG / JPEG files can be uploaded', // 只能上传jpg/png/jpeg文件
      upload_fail: 'Upload Fail', // 上传失败
      del_img: 'Delete pictures', // 删除图片
      large_img: 'Click the picture to view the large picture' // 点击图片查看大图

    },
    carMaintenance: { // 车辆保养列表
      txt_title_detail: 'Details of Vehicle Maintenance', // 车辆保养详情
      header_km: 'Mileage After Maintenance ', // 保养公里
      header_maintenance: 'Maintenance Or Not', // 是否需要保养
      label_maintenance: 'Maintenance Or Not', // 是否需要保养
      label_date: 'Maintenance Date', // 保养日期
      label_info: 'Maintenance Details', // 保养详情
      tip_date: 'Please choose maintenance date', // 请选择保养日期
      tip_info: 'Maintenance conditions, duration, vehicle problems during maintenance, etc', // 保养情况，时长，保养过程中车辆问题等
      tip_maintenance: 'Please select weather maintenance or not'// 请选择是否需要保养
    },
    cars: { // 车辆列表
      btn_enter_car: 'Enter Vehicle',
      txt_modify_car: 'Edit Vehile', // 修改车辆信息
      txt_see_detail: 'View Vehile', // 查看车辆信息
      sel_maintenance_date: 'Last Maintenance Date',
      label_operate: 'Operational Or Not', // 是否运营车
      label_maintenance_date: 'Last Maintenance Date', // 最后保养日期
      label_color: 'Color',
      label_valid: 'Validity Of Plate No', // 车证有效期
      label_tax_date: 'Last Tax Date', // 最后纳税日期
      label_insurance_date: 'Last Insurance Date', // 最后车险日期
      label_appearance: 'Appearance', // 外观状况
      label_belong: 'Owner', // 属于
      label_dentification: 'VIN', // 车辆识别号
      label_engine: 'Engine Number', // 引擎编号
      label_number: 'Vehicle Ownership Certificate No', // 车辆拥有证号码
      label_address: 'Vehicle Ownership Certificate', // 车辆拥有证所在
      label_car_adrress: 'Vehicle Number Certificate', // 车号证所在
      label_cylinder: 'Cylinder Capacity', // 气缸容量
      label_made: 'Year Of Manufacture', // 制造年份
      label_indebtedness: 'Indebtedness', // 负债人
      label_other: 'Other Information', // 其他信息
      tip_car_number: 'Plate No', // 请输入车牌号
      tip_color: 'Vehicle Type', // 请输入颜色
      tip_valid: 'Validity Of Plate No', // 请选择车证有效期
      tip_tax_date: 'Last Tax Date', // 请选择最后纳税日期
      tip_insurance_date: 'Last Insurance Date', // 请选择最后车险日期
      tip_appearance: 'Appearance', // 请输入外观状况
      tip_belong: 'Vehicle Owner', // 请输入属于
      tip_dentification: 'VIN', // 请输入车辆识别号
      tip_engine: 'Engine Number', // 请输入引擎编号
      tip_number: 'Vehicle Ownership Certificate No', // 请输入车辆拥有证号码
      tip_address: 'Vehicle Ownership Certificate', // 请输入车辆拥有证所在
      tip_car_adrress: 'Vehicle Number Certificate', // 请输入车号证所在
      tip_cylinder: 'Cylinder Capacity', // 请输入气缸容量
      tip_made: 'Year Of Manufacture', // 请选择制造年份
      tip_indebtedness: 'Indebtedness', // 请输入负债人
      tip_other: 'Other Information', // 请输入其他信息
      btn_normal: 'Set Normal', // 置为正常
      btn_repair: 'Repaired Log', // 维修记录
      btn_maintenance: 'Maintenance Log', // 保养记录
      txt_no_data: 'No Data', // 暂无数据
      label_km: 'Maintenance Kilometres', // 保养时公里
      header_travel_km: 'Accumulated driving kilometres', // 累积行驶公里
      header_operate: 'Operational Vehicles Or Not', // 是否运营车
      header_valid: 'Validity Of Plate No', // 车证有效期
      header_tax_date: 'Last Tax Date', // 最后纳税日期
      header_insurance_date: 'Last Insurance Date', // 最后车险日期
      header_maintenance_date: 'Last Maintenance Date', // 最后保养日期
      txt_normal_use: 'Normal Use', // 正常使用
      txt_improper_use: 'Stop Using', // 暂停使用
      txt_isdel_car: 'Whether to delete the vehicle', // 是否要删除车辆
      label_leijibaoyang: 'Accumulated Driving Kilometres', // 累计行驶公里
      label_shangcibaoyang: 'Last Actual Maintenance Kilometres', // 上次实际保养公里
      label_baoyang: 'Maintenance Kilometres', // 保养公里
      label_bencibaoyang: 'Actual Maintenance Kilometres', // 本次实际保养公里
      label_shijibaoyang: 'Actual Maintenance Kilometres', // 实际保养公里
      tip_shijibaoyang: 'Maintenance Kilometres', // 请输入实际保养公里
      tip_correct_shijibaoyang: 'Please enter valid actual maintenance kilometres', // 请输入正确的实际保养公里
      wait_maintain: 'Vehicles to be maintained', // 待保养车辆
      wait_use: 'Suspension of vehicles', // 暂停使用车辆
      after_maintain: 'Mileage after maintenance' // 保养后公里
    },
    drivers: { // 司机列表
      btn_enter_driver: 'Enter driver information', // 录入司机信息
      txt_modify: 'Modify driver information', // 修改司机信息
      header_name: 'Driver', // 司机姓名
      header_phone: 'Phone', // 手机号
      label_name: 'Driver', // 司机姓名
      label_phone: 'Phone', // 手机号
      tip_name: 'Please fill in the driver\'s name', // 请输入司机姓名
      tip_phone: 'Please enter your mobile number', // 请输入手机号
      tip_is_del: 'Do you want to delete driver' // 是否要删除司机
    },
    dailyReport: {
      txt_statistics: 'The Daily News counts the data before yesterday, including yesterday', // 日报统计昨天之前的数据，包括昨天
      td_use_summary: 'Summary of usage time', // 使用时长汇总
      td_free_summary: 'Summary of idle hours' // 空闲时长汇总
    },
    carChart: { // 车辆使用图
      header_time: 'Time', // 时间
      sel_day: 'Daily Enquiry' // 每日查询
    },
    driverDaily: {
      td_time_summary: 'Summary Of Working Hours' // 工作时长汇总
    },
    monthlyReport: { // 月结算报
      sel_month: 'Select Month', // 选择月份
      sel_settle: 'Settlement Status', // 结算状态
      option_account_wait: 'Settlement', // 待结算
      option_accounted: 'Settled', // 已结算
      header_month: 'Month', // 月份
      header_settle: 'Settlement Status', // 结算状态
      btn_settle: 'Settlement', // 结算
      btn_detail: 'Check the reconciliation table', // 查看对账表
      txt_settle: 'Successful Settlement', // 结算成功
      td_total: 'Total' // 汇总
    }
  },
  // 皇家花园
  royalGardens: {
    // 全部订单
    orders: {
      sel_order_type: 'Order Type', // 订单类型
      sel_department: 'Department', // 部门
      sel_start_date: 'Transaction Start Time', // 交易开始时间
      sel_end_date: 'Transaction End Time', // 交易结束时间
      header_department: 'Department', // 部门
      header_order_type: 'Order Type', // 订单类型
      header_enter_time: 'Entry Time', // 录入时间
      header_currency: 'Currency', // 币种
      header_amount: 'Amount', // 金额
      header_transaction_time: 'Transaction Time', // 交易时间
      header_entry_person: 'Entry person', // 录入人
      header_edit_time: 'Last Edit Time', // 最后编辑时间
      btn_enter_order: 'Add Order', // 录入订单
      txt_edit_order: 'Edit Order' // 编辑订单
    },
    // 录入订单
    enterOrder: {
      label_order_type: 'Order Type', // 订单类型
      label_department: 'Department', // 部门
      label_transaction_time: 'Transaction Time', // 交易时间
      label_currency: 'Currency', // 币种
      label_amount: 'Amount', // 金额
      label_remark: 'Remark', // 备注
      tip_order_type: 'Please Select Order Type', // 请选择订单类型
      tip_amount: 'Please Enter The Amount', // 请输入金额
      tip_department: 'Please Select Department', // 请选择部门
      tip_transaction_time: 'Please Select Transaction Time', // 请选择交易时间
      tip_remark: 'Please Enter remark', // 请输入备注
      tip_currency: 'Please Select Currency' // 请选择币种
    },
    daily: {
      header_total_order: 'Total Order Num', // 订单总数
      header_idr_amount: 'Total Amount(IDR)', // 印尼盾总金额
      header_order_no: 'Number Of Order' // 订单数量
    }
  },
  // 靶场订单
  clubOrder: {
    clubShare: {
      sel_order_no: 'Order number', // 订单号
      sel_username: 'Guest Name', // 用户姓名
      sel_order_source: 'Source Of order', // 订单来源
      sel_sale_type: 'Sales Type', // 销售类型
      sel_arrival_date: 'Check In', // 到店日期
      sel_arrival_sdate: 'Arrival Start Date', // 到店开始日期
      sel_arrival_edate: 'Arrival End Date', // 到店结束日期
      sel_meal_type: 'Package Type', // 套餐类型
      sel_discount: 'Discount Method', // 折扣方式
      sel_cancel_sdate: 'Write Off Start Date', // 核销开始日期
      sel_cancel_edate: 'Write Off End Date', // 核销结束日期
      sel_collection_currency: 'Receivable Currency', // 收款币种
      sel_collection_type: 'Payment Method', // 收款方式
      sel_order_state: 'Order Status', // 订单状态
      sel_pay_method: 'Payment Method', // 付款方式
      sel_pay_state: 'Payment Status', // 付款状态
      header_order_no: 'Order Number', // 订单号
      header_order_source: 'Source Of Order', // 订单来源
      header_sale_type: 'Sales Type', // 销售类型
      header_username: 'Guest Name', // 用户姓名
      header_num: 'Number Of Copies', // 份数
      header_people: 'Number Of People', // 人数
      header_arrival_time: 'Shop Arrival Time', // 到店时间
      header_meal_type: 'Package Type', // 套餐类型
      header_pay_method: 'Payment Method', // 付款方式
      header_pay_state: 'Payment Status', // 付款状态
      header_collection_currency: 'Receivable Currency', // 收款币种
      header_collection_type: 'Payment Method', // 收款方式
      header_collection_amount: 'Actual Amount Of Receipt', // 实际收款金额
      header_cancel_time: 'Write Off Time', // 核销时间
      header_order_state: 'Order Status', // 订单状态
      header_order_time: 'Order time', // 下单时间
      option_pay_last: 'After Payment', // 后付款
      option_pay_first: 'Pay First', // 先付款
      option_no_pay: 'Unpaid', // 未支付
      option_paied: 'Paid', // 已支付
      option_stay_store: 'Stay In Store', // 待到店
      option_completed: 'Completed', // 已完成
      option_yx: 'A Pin', // 一销
      option_ex: 'The Second Pin', // 二销
      option_yj: 'Original Price', // 原价
      option_bz: '20 percent off', // 8折
      option_mf: 'Free Admissi', // 免费
      option_rmb: 'RMB', // 人民币
      option_ynd: 'IDR', // 印尼盾
      option_mj: 'USD', // 美金
      option_wx: 'WeChat', // 微信
      option_zfb: 'Alipay', // 支付宝
      option_xx: 'Offline Payment', // 线下
      option_sk: 'Pay By Card', // 刷卡
      option_xj: 'Cash' // 现金
    },
    enterOrder: { // 录入订单
      btn_enter_offline: 'Input Offline Orders', // 录入线下订单
      btn_enter_free: 'Enter Free Channel Order', // 录入免费渠道订单
      txt_modify: 'Modify Offline Order', // 修改线下订单
      txt_modify_free: 'Modify offline free order', // 修改线下免费订单
      label_order_source: 'Source Of Order', // 订单来源
      label_sale_type: 'Sales Type', // 销售类型
      label_guide: 'Name Of Tour Guide', // 导游姓名
      label_travel: 'Name Of Travel Agency', // 旅行社名称
      label_username: 'Guest Name', // 用户姓名
      label_num: 'Number Of Copies', // 份数
      label_people: 'Number Of People', // 人数
      label_address: 'Delivery Address', // 接送地址
      label_arrival_time: 'Shop Arrival Time', // 到店时间
      label_choose_meal: 'Optional Package', // 选择套餐
      label_discount: 'Discount Method', // 折扣方式
      label_collection_type: 'Payment Method', // 收款方式
      label_pay_method: 'Payment Method', // 付款方式
      label_remark: 'Remark', // 备注
      label_bullet: 'Bullet Selection', // 选择子弹
      tip_order_source: 'Please select the source of the order.', // 请选择订单来源
      option_free: 'Free', // 免费
      header_choose: 'Choose', // 选择
      header_num: 'Num', // 数量
      header_meal_name: 'Name Of Package', // 套餐名称
      header_bullets: 'Number Of Bullets', // 子弹数量
      header_bullets_type: 'Bullet Type', // 子弹型号
      header_bullets_stock: 'Bullet Inventory', // 子弹库存
      header_price: 'Indonesian Shield Price', // 印尼盾价格
      header_bullets_name: 'Bullet Name', // 子弹名称
      tip_idr_price: 'Please input rupiah collection amount', // 请输入印尼盾收款金额
      tip_rmb_price: 'Please enter the RMB collection amount', // 请输入人民币收款金额
      tip_doller_price: 'Please enter US dollar collection amount', // 请输入美元收款金额
      radio_pay_last: 'After Payment', // 后付款
      tip_username: 'Please enter user name', // 请输入用户姓名
      tip_guide: 'Please enter the name of the tour guide', // 请输入导游姓名
      tip_travel: 'Please enter the name of travel agency', // 请输入旅行社名称
      tip_address: 'Please enter the transfer address', // 请输入接送地址
      tip_receive_price: 'Please enter the collection amount', // 请输入收款金额
      tip_correct_format: 'Please enter the correct format', // 请输入正确的格式
      tip_correct_amount: 'Please enter the correct amount', // 请输入正确的金额
      tip_num: 'Please enter the number of copies', // 请输入份数
      tip_people: 'Please enter the number of people', // 请输入人数
      tip_bullet_num: 'Please enter the number of bullets', // 请输入子弹数量
      tip_correct_bullet: 'Please enter a valid number of bullets', // 请输入有效的子弹数量
      tip_bullet_one: 'Please select at least one bullet package', // 请至少选择一项子弹套餐
      tip_one: 'Please select at least one' // 请至少选择一项
    },
    viewDetails: { // 查看详情
      title_pay_info: 'Payment Information', // 付款信息
      title_paied_info: 'Payment information', // 支付信息
      label_order_no: 'Booking No.', // 订单编号
      label_order_type: 'order Type', // 订单类型
      btn_cancel_order: 'Cancellation Of Order', // 取消订单
      btn_back_order: 'Chargeback', // 退单
      btn_verification: 'Confirm', // 核销
      btn_modify_order: 'Order Modification', // 修改订单
      header_price: 'Unit Price', // 单价
      txt_empty: 'Empty', // 当前为空
      btn_choose_meal: 'Optional Package', // 选择套餐
      header_pickup_address: '', // 接送地址
      header_pay_time: 'Payment Date', // 支付时间
      header_pay_method: 'Payment Method', // 支付方式
      header_pay_currency: 'Currency Of Payment', // 支付币种
      header_pay_order: 'Payment Order SN', // 支付订单号
      header_pay_amount: 'Payment Amount', // 支付金额
      header_remark: 'Remark', // 备注
      txt_confirm_cancel: 'Are You Sure Confirm Cancel', // 是否确认取消
      txt_refund_reasons: 'Reasons For Cancel', // 退单原因
      tip_refund_reasons: 'Please enter chargeback reason', // 请输入退单原因
      txt_confirm_club: 'Are You Sure Confirm Club', // 是否确认核销订单
      txt_id_no: 'id_no' // 护照
    },
    daily: {
      daily_rules: 'Statistics "completed" status, and the arrival time is also the same day\'s order.', // 统计“已完成”状态，且到店时间也在当天的订单。
      header_order_num: 'Number Of Order', // 订单数量,
      header_meal_num: 'Number Of package', // 套餐数量
      header_rmb_amount: 'CNY Amount', // 人民币收款金额
      header_idr_amount: 'IDR Amount', // 印尼盾收款金额
      header_us_amount: 'USD Amount', // 美元收款金额
      header_amount: 'Amount' // 收款金额
    },
    enterPackage: { // 录入靶场套餐
      title: 'Enter Range Package', // 录入靶场套餐
      h_sale_price: 'Price', // 售价
      h_dis_price: 'Discount Price', // 折扣价
      h_type_price: 'Price Type', // 价格类型
      h_is_more: 'Multiple Packages Or Not', // 是否多套餐
      h_is_head: 'Headquarters Package Or Not', // 是否总部套餐
      h_package: 'Package', // 套餐
      h_product: 'Product', // 产品
      h_bullet_name: 'Product Name', // 产品名称
      h_is_reduce: 'Deduct Inventory Or Not', // 是否扣库存
      h_description: 'Description', // 说明
      is_del: 'Do you want to disable package', // 是否要禁用套餐
      radio_head: 'Headquarters', // 总部
      radio_normal: 'Ordinary', // 普通
      tip_bullet_type: 'Bullet type', // 请选择子弹型号
      tip_complete: 'Please complete the package information', // 请把套餐信息填写完整
      tip_sale: 'Please enter the selling price', // 请输入售价
      tip_dis: 'Please enter discount price', // 请输入折扣价
      tip_name: 'Please enter package name', // 请输入套餐名称
      tip_price: 'Please select price type', // 请选择价格类型
      tip_head: 'Please choose whether the headquarters package', // 请选择是否总部套餐
      tip_more: 'Please choose more packages', // 请选择是否多套餐
      disable_suc: 'Disable success', // 禁用成功
      tip_product_name: 'Product name', // 请填写产品名称
      tip_bullet_num: 'Number of bullets' // 请填写子弹数量
    }
  },
  // 数据统计
  dataStats: {
    tit_income: 'Revenue statistics', // 收入统计
    tit_income_hotel: 'Total hotel revenue', // 酒店总收入
    tit_income_club: 'Total range revenue', // 靶场总收入
    tit_income_car: 'Total fleet revenue', // 车队总收入
    tit_income_town: 'Total income of Chinatown', // 中国城总收入
    tit_income_garden: 'Total income of Royal Garden', // 皇家花园总收入
    income_percent: 'Proportion of business income', // 各业务收入占比
    unit: 'Unit', // 单位
    income_month: 'Monthly income statistics', // 月收入统计
    btn_export: 'Export', // 导出
    tit_income_30: 'Total revenue statistics in the last 30 days', // 最近30天总收入统计
    txt_rmb: 'CNY', // 人民币
    txt_ynd: 'IDR', // 印尼盾
    total: 'Gross income', // 总收入
    business_income: 'Business income', // 业务收入
    income: 'Income', // 收入
    car_channel_income: 'Revenue statistics of various channels of the fleet', // 车队各渠道收入统计
    car_income_month: 'Monthly statistics of fleet revenue', // 车队收入月份统计
    car_income_30: 'Fleet revenue statistics in the last 30 days', // 车队最近30天收入统计
    order_stats: 'Order statistics', // 订单统计
    car_channel_order: 'Order statistics of each channel of the fleet', // 车队各渠道订单统计
    car_order_month: 'Monthly statistics of fleet orders', // 车队订单月份统计
    car_order_30: 'Statistics of orders of the fleet in the last 30 days', // 车队最近30天订单量统计
    operate_stats: 'Operation data statistics', // 运营数据统计
    car_model: 'Use model statistics', // 使用车型统计
    car_use: 'Vehicle use statistics', // 车辆用途统计
    channel: 'Channel', // 渠道
    order_total: 'Total order quantity', // 总订单量
    order: 'Order', // 单
    order_num: 'Order quantity', // 订单量
    car_use_total: 'Total use vehicle', // 总使用车辆
    car: 'Vehicle', // 辆
    models: 'Vehicle type', // 车型
    use: 'Purpose', // 用途
    club_channel_income: 'Income statistics of various channels of shooting range', // 靶场各渠道收入统计
    channel_order: 'Order statistics of each channel', // 各渠道订单统计
    package_sale: 'Sales statistics of each package', // 各套餐销量统计
    club_order_month: 'Monthly order quantity statistics of shooting range', // 靶场月订单量统计
    order_30: 'Total order statistics in the last 30 days', // 最近30天总订单统计
    club_order_type: 'Shooting range order sales type statistics', // 靶场订单销售类型统计
    bullet_stats: 'Statistics of bullet consumption in the last 30 days', // 最近30天子弹消耗量统计
    total_sales: 'Total sales volume', // 总销量
    fen: '', // 份
    total_order: 'Total singular', // 总单数
    sale_type: 'Sales type', // 销售类型
    hotel_channel_income: 'Revenue statistics of various channels of the hotel', // 酒店各渠道收入统计
    hotel_income_month: 'Monthly revenue statistics of hotels', // 酒店月收入统计
    hotel_income_30: 'Revenue statistics of the hotel in the last 30 days', // 酒店最近30天收入统计
    hotel_channel_order: 'Order statistics of all channels of the hotel', // 酒店各渠道订单统计
    hotel_order_month: 'Monthly statistics of hotel orders', // 酒店订单月份统计
    hotel_order_30: 'Statistics of orders of the hotel in the last 30 days', // 酒店最近30天订单量统计
    hotel_room_month: 'Monthly statistics of hotel rooms', // 酒店入住房间数月份统计
    hotel_room_30: 'Statistics of the number of rooms entered into the hotel in the last 30 days', // 酒店最近30天入住房间数统计
    hotel_channel_room: 'Monthly statistics of the number of rooms in each channel', // 各渠道入住房间数月份统计
    hotel_channel_room_30: 'Statistics of the number of rooms in each channel in the last 30 days', // 最近30天各渠道入住房间数统计
    stats: 'Statistics', // 统计
    room_num: 'Number of rooms', // 房间数
    china_channel_income: 'China town channel revenue statistics', // 中国城各渠道收入统计
    china_income_month: 'Monthly income statistics of Chinatown', // 中国城月收入统计
    china_income_30: 'Latest 30 days revenue statistics of Chinatown', // 中国城最近30天收入统计
    lobby_channel_income: 'Lobby by channel revenue statistics', // Lobby各渠道收入统计
    lobby_income_month: 'Lobby monthly income statistics', // Lobby月收入统计
    lobby_income_30: "Lobby's last 30 days of revenue statistics" // Lobby最近30天收入统计
  }
}
